import Entity from './entity'
export default class Floor extends Entity<number>{
    fname:string;
    status:Number=1;
    ftId:Number;
}